// get customer list
export const RESET_GET_CUSTOMER_LIST = "RESET_GET_CUSTOMER_LIST";
export const GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST";
export const GET_CUSTOMER_LIST_SUCCESS = "GET_CUSTOMER_LIST_success";
export const GET_CUSTOMER_LIST_FAILURE = "GET_CUSTOMER_LIST_failure";
